// extracted by mini-css-extract-plugin
module.exports = {"root":"section-five_root__uMpGt","inner":"section-five_inner__VkqFl"};